export default __webpack_public_path__ + "static/media/img5.98100a4f.webp";